import { Icon as ManifestIcon } from '@project44/manifest-ui-deprecated';

// COMPONENT
export const Icon = ({
  name,
  size = '1rem',
}: {
  name: string;
  size?: string;
}) => (
  <ManifestIcon data-testid="icon" size={size}>
    <use xlinkHref={`#icon-${name}`} />
  </ManifestIcon>
);
